import { connect } from "react-redux";
import CommissionPayoutCasesList from "./CommissionPayoutCasesList";
import { bindActionCreators } from "redux";
import { commissionPayoutCasesRequest, validateInvoiceStatus, previewInvoiceRequest, raiseInvoiceWithReconRequest } from "services/redux/CarLoan/action";

const mapStateToProps = (state) => ({
    commissionPayoutResponse : state.CarLoan.commissionPayoutResponse,
    validateStatusResponse : state.CarLoan.validateStatusResponse,
    previewInvoiceResponse : state.CarLoan.previewInvoiceResponse,
    raiseInvoiceResponse : state.CarLoan.raiseInvoiceResponse
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        commissionPayoutCasesRequest,
        validateInvoiceStatus,
        previewInvoiceRequest,
        raiseInvoiceWithReconRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CommissionPayoutCasesList);